import { Api } from './api/axios-config';

export class FirebaseService {
     private static api = Api();

     public static async createUser(email: string, password: string, displayName: string) {
         try {
           const response = await this.api.post('firebase/create-user', {
             email: email,
             password: password,
             displayName: displayName,
           });
           return response.data
         } catch (e) {
           console.log(e)
         }
       }
     public static async getPhotoImage(businessId: number) : Promise<string> {
      try{
        const PhotoURL = await this.api.get(`firebase/user-photo/${businessId}`)
        return PhotoURL.data;
      } catch(e) {
        return '';
      }
     }       
}